export { UpdateLectureMutation } from './update-lecture';
export { RemoveLectureMutation } from './remove-lecture';
